// extracted by mini-css-extract-plugin
module.exports = {"admission":"admission_admission__21sOY","morewrap":"admission_morewrap__2rqdG","more":"admission_more__1EmUe"};